import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  sharedVariable: string;

  private currentUserSubject = new BehaviorSubject<any>(SharedService.readStoredUser());
  /** Header & Co. abonnieren Avatar/Kürzel-Updates */
  currentUser$ = this.currentUserSubject.asObservable();

  constructor() { }

  get currentUser(): any {
    return this.currentUserSubject.value;
  }

  set currentUser(user: any) {
    this.setCurrentUser(user);
  }

  static readStoredUser(): any {
    try {
      const raw = localStorage.getItem('currentUser');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  setCurrentUser(user: any): void {
    if (user) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    } else {
      localStorage.removeItem('currentUser');
    }
    this.currentUserSubject.next(user);
  }

  /** Teildaten mergen (z. B. nach Avatar-Upload) */
  patchCurrentUser(patch: Record<string, any>): void {
    const next = { ...(this.currentUserSubject.value || {}), ...patch };
    this.setCurrentUser(next);
  }

  /** Avatar-URL aus image bauen; null wenn kein Bild */
  static resolveAvatarUrl(user: any, cacheBust = false): string | null {
    if (!user) {
      return null;
    }
    const image = user.image;
    if (image && String(image) !== 'null' && String(image) !== 'undefined') {
      const filename = String(image).split('/').pop();
      const url = `${environment.prismaApiUrl}/api/avatar/${filename}`;
      return cacheBust ? `${url}?t=${Date.now()}` : url;
    }
    const legacy = user.avatar_url;
    if (
      legacy &&
      typeof legacy === 'string' &&
      !legacy.endsWith('/api/avatar/') &&
      !legacy.includes('/avatar/null') &&
      !legacy.includes(':8000/api/avatar/')
    ) {
      return legacy;
    }
    return null;
  }

  /** Google-Style: short oder Initialen aus Vor-/Nachname */
  static resolveInitials(user: any): string {
    if (!user) {
      return '?';
    }
    const short = String(user.short || '').trim();
    if (short) {
      return short.substring(0, 2).toUpperCase();
    }
    const first = String(user.firstname || '').trim();
    const last = String(user.auth_user || user.name || '').trim();
    const a = first.charAt(0);
    const b = last.charAt(0);
    const initials = (a + b).toUpperCase();
    return initials || '?';
  }
}
